// Utilitários de z-index para overlays (Dialog, Drawer, etc.).
//
// O problema recorrente: um Drawer (ex.: filtro) aberto de dentro de um Dialog
// (ex.: a lupa de um lookup) acaba ficando ATRÁS do Dialog, porque o Dialog usa
// z-index 11000 e o Drawer tem um default mais baixo.
// Filtro => lupa => filtro 
export function getTopOverlayZIndex() {
  let maxZIndex = 0;
  for (const el of document.querySelectorAll('body *')) {
    const style = window.getComputedStyle(el);
    if (
      style.position !== 'fixed' ||
      style.display === 'none' ||
      style.visibility === 'hidden'
    )
      continue;
    const z = parseInt(style.zIndex, 10);
    if (!isNaN(z) && z > maxZIndex && z < 100000) maxZIndex = z;
  }
  return maxZIndex;
}

// Retorna um z-index acima do Dialog mais alto na tela (>= 11000)
// quando não há Dialog acima (deixando o componente usar seu z-index default).
export function getZIndexAboveDialog() {
  const max = getTopOverlayZIndex();
  return max >= 11000 ? max + 1 : undefined;
}